import React, { useEffect, useState } from "react";
import { FiCheck, FiX, FiAlertCircle, FiInfo } from "react-icons/fi";

export default function Toast({
  open,
  title = "Created Successfully!",
  message = "Scanner has been created successfully.",
  type = "success",
  duration = 4000,
  onClose,
}) {
  const [progress, setProgress] = useState(0); // Start at 0%

  useEffect(() => {
    if (!open) {
      setProgress(0);
      return;
    }

    const intervalTime = 20;
    const step = (intervalTime / duration) * 100;

    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          if (onClose) onClose();
          return 100;
        }
        return prev + step; // Increase progress
      });
    }, intervalTime);

    return () => clearInterval(timer);
  }, [open, duration, onClose]);

  if (!open) return null;

  const config = {
    success: {
      icon: <FiCheck className="text-lg text-black" />,
      iconBg: "bg-[var(--color-primary)]",
      progressBar: "bg-[var(--color-primary)]",
    },
    error: {
      icon: <FiX className="text-lg text-white" />,
      iconBg: "bg-red-500",
      progressBar: "bg-red-600",
    },
    warning: {
      icon: <FiAlertCircle className="text-lg text-white" />,
      iconBg: "bg-amber-500",
      progressBar: "bg-amber-600",
    },
    info: {
      icon: <FiInfo className="text-lg text-white" />,
      iconBg: "bg-blue-500",
      progressBar: "bg-blue-600",
    },
  }[type];

  return (
    <div
      className="fixed top-5 right-5 z-[9999] flex w-[90%] max-w-[360px] flex-col overflow-hidden rounded-[16px] bg-white shadow-2xl transition-all duration-300 ease-in-out sm:w-auto sm:min-w-[320px]"
      style={{
        boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.12)",
      }}
    >
      {/* Toast Content */}
      <div className="flex items-center justify-between p-4 gap-3">
        <div
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${config.iconBg}`}
        >
          {config.icon}
        </div>

        <div className="flex flex-1 flex-col overflow-hidden pr-2">
          <h4 className="text-[14px] font-bold text-[#1A1A1A] truncate">
            {title}
          </h4>
          <p className="text-[12px] text-[#64748B] truncate mt-0.5">
            {message}
          </p>
        </div>

        <button
          onClick={onClose}
          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-[#EF4444] text-red-400 hover:bg-red-50 hover:text-red-600 transition-colors"
          aria-label="Close Toast"
        >
          <FiX className="text-base" />
        </button>
      </div>

      {/* Progress Bar Container - Fills Left to Right */}
      <div className="h-1 w-full bg-gray-100">
        <div
          className={`h-full ${config.progressBar} transition-all ease-linear`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}